import { Component } from '@angular/core';
import { ErrorPageComponent } from '@component/error-page/error-page.component';

@Component({
  selector: 'app-error-not-logged-in',
  templateUrl: './error-not-logged-in.component.html',
})
export class ErrorNotLoggedInComponent extends ErrorPageComponent {
}
